/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  DeleteOperationChainMutationRequest,
  DeleteOperationChainMutationResponse,
} from "../types/DeleteOperationChain.ts"
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { mutationOptions, useMutation } from "@tanstack/react-query"

export const deleteOperationChainMutationKey = () =>
  [{ url: "/v1/operation-chain/delete-operation-chain" }] as const

export type DeleteOperationChainMutationKey = ReturnType<
  typeof deleteOperationChainMutationKey
>

/**
 * @summary Delete an operation chain
 * {@link /v1/operation-chain/delete-operation-chain}
 */
export async function deleteOperationChain(
  data: DeleteOperationChainMutationRequest,
  config: Partial<RequestConfig<DeleteOperationChainMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    DeleteOperationChainMutationResponse,
    ResponseErrorConfig<Error>,
    DeleteOperationChainMutationRequest
  >({
    method: "DELETE",
    url: `/v1/operation-chain/delete-operation-chain`,
    data: requestData,
    ...requestConfig,
  })
  return res
}

export function deleteOperationChainMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<DeleteOperationChainMutationRequest>> & {
    client?: Client
  } = {}
) {
  const mutationKey = deleteOperationChainMutationKey()
  return mutationOptions<
    ResponseConfig<DeleteOperationChainMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: DeleteOperationChainMutationRequest },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return deleteOperationChain(data, config)
    },
  })
}

/**
 * @summary Delete an operation chain
 * {@link /v1/operation-chain/delete-operation-chain}
 */
export function useDeleteOperationChain<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<DeleteOperationChainMutationResponse>,
      ResponseErrorConfig<Error>,
      { data: DeleteOperationChainMutationRequest },
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig<DeleteOperationChainMutationRequest>> & {
      client?: Client
    }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey =
    mutationOptions.mutationKey ?? deleteOperationChainMutationKey()

  const baseOptions = deleteOperationChainMutationOptions(
    config
  ) as UseMutationOptions<
    ResponseConfig<DeleteOperationChainMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: DeleteOperationChainMutationRequest },
    TContext
  >

  return useMutation<
    ResponseConfig<DeleteOperationChainMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: DeleteOperationChainMutationRequest },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<DeleteOperationChainMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: DeleteOperationChainMutationRequest },
    TContext
  >
}
